import { render, staticRenderFns } from "./SimpleButtonDropdown.vue?vue&type=template&id=3c1dc28e"
import script from "./SimpleButtonDropdown.vue?vue&type=script&lang=js"
export * from "./SimpleButtonDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports